import React from 'react';

import TopArticlesSection, { Page } from '@components/FeedItems/TopArticlesSection';
import MainFeed from '@components/MainFeed';
import Tabs from '@components/Tabs';
import { Env } from '@contexts/AppContext';
import { Article } from '@interfaces/homepage';
import { finance_path, technology_path } from '@routes';
import { User } from '@utils/backend-api/currentUser';

import Header from './Header';
import PageContainer from './PageContainer';

interface HighlightProps {
  env: Env;
  feedArticles: Article[];
  header: string;
  highlightType: string;
  initialCurrentUser?: User;
  isNativeApp?: boolean;
  isWebview: boolean;
  nativeAppVersion?: string;
  page?: number;
  showBookmarksFlagEnabled?: boolean;
  sideArticles: Article[];
  subheader: string;
  topArticle: Article;
  view: string;
}

const POPULAR = 'popular';
const RECENT = 'recent';
enum HighlightTypeToPath {
  technology = technology_path,
  finance = finance_path,
}

const Highlight = ({
  env,
  feedArticles,
  header,
  highlightType,
  initialCurrentUser,
  isNativeApp,
  isWebview,
  nativeAppVersion,
  page,
  showBookmarksFlagEnabled,
  sideArticles,
  subheader,
  topArticle,
  view,
}: HighlightProps): JSX.Element => {
  return (
    <PageContainer
      initialCurrentUser={initialCurrentUser}
      env={env}
      isNativeApp={isNativeApp}
      isWebview={isWebview}
      nativeAppVersion={nativeAppVersion}
      showBookmarksFlagEnabled={showBookmarksFlagEnabled}
    >
      <Header header={header} subheader={subheader} />
      <Tabs
        customPath={HighlightTypeToPath[highlightType]}
        tabs={[
          {
            to: RECENT,
            text: 'Latest',
          },
          {
            to: POPULAR,
            text: 'Most popular',
          },
        ]}
        view={view}
      />
      {feedArticles?.length === 0 && !sideArticles && !topArticle ? (
        <p className="mx-32 my-8 font-suisse-intl text-body-md text-primary-black sm:mx-0 sm:text-body-lg">
          Looks like something’s wrong. Try the{' '}
          <a
            className="underline hover:text-primary-magenta dark:hover:text-primary-pink"
            href={`${HighlightTypeToPath[highlightType]()}?view=${RECENT}`}
          >
            Latest
          </a>{' '}
          tab for the most recent articles.
        </p>
      ) : (
        <>
          {(!page || page === 1) && (
            <TopArticlesSection
              page={Page.Highlight}
              sideArticles={sideArticles}
              topArticle={topArticle}
            />
          )}
          <div className="px-0 lg:px-0">
            {feedArticles?.length > 0 && (
              <MainFeed
                feedContent={feedArticles}
                highlightType={highlightType}
                includeTabs={false}
                page={page}
                pageSize={6}
                view={view}
              />
            )}
          </div>
        </>
      )}
    </PageContainer>
  );
};

export default Highlight;
